<template>
  <div v-if="showFlag">
    <a-card style="margin-top: 24px" :bordered="false" title="计算参数信息">
      <a-row :gutter="[16,32]">
        <a-form-model-item :label-col="{span: 6, offset: 4}" :wrapper-col="{span: 6}" label="评标基准价：">
          <a-input :value="comprehensiveScore.benchmarkPrice" disabled='disabled' />
        </a-form-model-item>
      </a-row>
      <a-row :gutter="[16,32]">
        <a-form-model-item :label-col="{span: 6, offset: 4}" :wrapper-col="{span: 6}" label="E：">
          <a-input :value="comprehensiveScore.evalue1" disabled='disabled' />
        </a-form-model-item>
      </a-row>
    </a-card>
    <a-card :bordered='false' title="评标价得分列表">
      <a-table :columns="columns" :data-source="dataScore" :pagination="false">
        <template slot="footer">
          <div style='margin-top: 20px;'>
            <b><span>说明：</span></b><br>
            <b><span>偏差率=|100%×（投标人评标价-评标基准价）/评标基准价|</span></b><br>
            <b><span>偏差率计算保留小数点后两位，小数点后第三位采用“四舍五入”。</span></b><br>
            <b><span>评标价得分={{comprehensiveScore.priceScore}}-偏差率×100*E,E={{comprehensiveScore.evalue1}}</span></b><br>
            <b><span>评标价得分计算保留小数点后两位，小数点后第三位采用“四舍五入”。</span></b><br>
          </div>
        </template>
      </a-table>
      <div align="center" v-if='!isCheckPriceScore' :loading='isCheckPriceScoreLoading' style='padding-top: 20px;'>
        <a-button v-show="isHeadman" type="primary" @click="endPriceScore">
          确认评标价得分情况
        </a-button>
        <span v-show="!isHeadman" >
          等待组长评标价得分情况
        </span>
      </div>
    </a-card>
  </div>
</template>

<script>

import { httpAction, getAction, postAction,putAction } from '@/api/manage'
import calculator from '@/utils/decimal'
import { message } from 'ant-design-vue'
import pick from 'lodash.pick'

export default {
  name: 'AppraiseSpeedConstructionPriceScore',
  data() {
    return {
      dataScore: [],
      comprehensiveScore:{},
      isCheckPriceScore: true,
      isCheckPriceScoreLoading: false,
      isHeadman: false,
      showFlag:false,
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          dataIndex: 'bidderName',
        },
        {
          title: '报价（元）',
          dataIndex: 'bidPrice',
        },
        {
          title: '偏差率',
          dataIndex: 'offset',
          customRender: function(t, r, index) {
            return calculator(t).multiply(100).toNumber() + "%";
          }
        },
        {
          title: '评标价得分',
          dataIndex: 'evalScore',
        }
      ],
    }
  },
  props: ['instStepId','workflowInstanceId','sectionId'],
  created() {
    this.getCommitteeMemExpert();
    this.getCheckStatus();
    this.getDataInfo();
  },
  methods: {
    getCommitteeMemExpert() {
      getAction('/ebid-ce/boCommitteeMem/getCommitteeMemExpert/' + this.workflowInstanceId , {}).then(res => {
        if (res.success) {
          this.isHeadman = res.result
        } else {
        }
      })
    },
    getCheckStatus() {
      getAction('/ebid-ce/boOpenStatus/getBoOpenStatus', {
        sectionId: this.sectionId,
      }).then(res => {
        if (res.success) {
          if( res.result != null && res.result.isKstandPriceFinish != "1") {
            this.$message.warning("需操作评标基准价后方可查看");
          }else
          {
            this.showFlag=true;
          }
        } else {
          this.$message.warning(res.message)
        }
      })
      getAction('/ebid-ce/boAppraiseStatus/getBoAppraiseStatus/' + this.workflowInstanceId , {}).then(res => {
        if (res.success) {
          if( res.result != null && res.result.isCheckPriceScore != "1") {
            this.isCheckPriceScore = false;
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    getDataInfo() {
      getAction('/ebid-ce/boAppraisePriceScore/speedConstructionComprehensiveScoreInfo/' + this.sectionId + "/" + this.instStepId , {}).then(res => {
        if (res.success) {
          this.comprehensiveScore = res.result;
          this.dataScore = res.result.bidderComprehensiveScoreList;
        } else {
        }
      })
    },
    endPriceScore() {
      this.isCheckPriceScoreLoading = true;
      let that = this;
      this.$confirm({
        title: '提示',
        content: '是否确认综合得分?',
        okText: '确定',
        /*okType: 'danger',*/
        cancelText: '取消',
        onOk() {
          let datas = [];
          for (let i = 0; i < that.dataScore.length; i++) {
            let data = {};
            data.bidderId = that.dataScore[i].bidderId;
            data.bidderName = that.dataScore[i].bidderName;
            data.bidderCode = that.dataScore[i].bidderCode;
            data.evalScore = that.dataScore[i].evalScore;
            data.workflowInstanceId = that.workflowInstanceId;
            data.instStepId = that.instStepId;
            data.sectionId = that.sectionId;
            datas.push(data)
          }
          postAction('/ebid-ce/boGroupResults/endPriceScore/' + that.workflowInstanceId + "/" + that.instStepId , datas).then((res) => {
            if (res.success) {
              that.isCheckPriceScore = true;
              that.$message.success("当前环节已结束！");
              that.$emit('getNewWfInst');
            } else {
              that.$message.error(res.message);
            }
            that.isCheckPriceScoreLoading = false;
          }).catch(() => {
            that.isCheckPriceScoreLoading = false;
            that.$message.error("当前操作失败，请重试！");
          })
        },
        onCancel() {
          that.isCheckPriceScoreLoading = false;
          console.log('Cancel');
        },
      });
    },
  }
}
</script>

<style scoped>

</style>